import React, { forwardRef, useCallback, useRef } from 'react';
import { Icon } from '../../../../icon';
import { Button } from '../../../../button';
import { SearchInput, Wrapper } from './styled';
const SearchIcon = () => React.createElement(Icon, { name: "search" });
export const TableSearch = forwardRef(function TableSearch({ searchValue, setSearchValue, searchData, isShowResetSearchBtn, resetSearch, prependButton, appendButton, ...rest }, ref) {
    const searchInputRef = useRef(null);
    const handleResetSearch = useCallback(() => {
        if (resetSearch)
            resetSearch();
        if (searchInputRef.current)
            searchInputRef.current.focus();
    }, [resetSearch]);
    const handleSearch = useCallback(({ target }) => {
        setSearchValue(target.value);
        if (!Boolean(target.value)) {
            searchData('');
        }
    }, [setSearchValue, searchData]);
    const submitSearch = useCallback((e) => {
        e.preventDefault();
        searchData();
    }, [searchData]);
    const handleKeyUp = useCallback((e) => {
        if (e.key === 'Escape') {
            setSearchValue('');
            searchData('');
        }
    }, [searchData, setSearchValue]);
    return (React.createElement(Wrapper, { ref: ref, ...rest, onSubmit: submitSearch },
        React.createElement(SearchInput, { ref: searchInputRef, value: searchValue, onChange: handleSearch, onKeyUp: handleKeyUp, prependInnerIcon: React.createElement(React.Fragment, null,
                React.createElement(SearchIcon, null),
                prependButton || null), appendInnerIcon: React.createElement(React.Fragment, null,
                isShowResetSearchBtn && resetSearch ? (React.createElement(Button, { onClick: handleResetSearch, variant: "text", StartIcon: React.createElement(Icon, { name: "close_outline" }) })) : undefined,
                appendButton || undefined), sizeComponent: "medium", placeholder: "Search ..." })));
});
